<app-viewer-header (startNextAction)="startNextAction()"></app-viewer-header>

<ng-container *ngIf="displayAsPerformActionPage">
    <div class="row row-cols-12">
        <div
            class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1 offset-0 offset-sm-0 offset-md-1 offset-lg-{{defaultOffsetLg-zoomFactor}} offset-xl-{{defaultOffsetXl-zoomFactor}} actionlistbar">
            <app-action-side-list (startNextAction)="startNextAction()"></app-action-side-list>
        </div>
        <div class="col-10 col-sm-10 col-md-9 col-lg-{{columnsLg}} col-xl-{{columnsXl}} document-viewer"
            [style.padding-bottom]="paddingBelowLastPage+'px'">
            <div *ngFor="let document of documentsToShow" class="me-2 me-lg-0">
                <!-- PDF -->
                <!-- Summary visible only on xl -->
                <app-performactiondocumentpdf *ngIf="document.documentType == 'RegularPdf'" [actions]="actions"
                    [actionsOtherActors]="actionsOtherActors" [document]="document" [request]="request"
                    [buttonsEnabled]="buttonsEnabled" [zoomFactor]="zoomFactor" (sign)="StartSignAction($event);"
                    #performactiondocumentpdf></app-performactiondocumentpdf>
                <!-- XBRL -->
                <app-performactiondocumentrendering *ngIf="document.documentType != 'RegularPdf'" [document]="document"
                    [request]="request" #performactiondocumentrendering></app-performactiondocumentrendering>

                <!-- New Summaries (it hides if NO Details to show)-->
                <div class="bg-white rendereddocumentsummary-box">
                    <app-document-details-summary [documentGuid]="document.id" [requestGuid]="request.id"
                        [documentType]="document.documentType" [documents]="request.documentInfo"></app-document-details-summary>
                    <app-document-actor-summary [document]="document"></app-document-actor-summary>
                    <app-document-actions-for-actor [documentIsAPdf]="document.documentType == 'RegularPdf'"
                        [documentGuid]="document.id" (sign)="StartSignAction($event);"></app-document-actions-for-actor>
                </div>

            </div>

            <div class="d-none d-lg-block position-fixed top-100 start-50 translate-middle">
                <div class="position-absolute zoombox-viewer">
                    <div class="btn-group btn-sm btn-shadow me-2">
                        <button type="button" [disabled]="zoomFactor === -1"
                            class="btn btn-sm pdf-preparation-dialog-buttons-border text-primary"
                            (click)="zoom(zoomFactor - 1)"><em class="bi bi-zoom-out"></em></button>
                        <button type="button" [disabled]="zoomFactor === 1"
                            class="btn btn-sm pdf-preparation-dialog-buttons-border text-primary"
                            (click)="zoom(zoomFactor + 1)"><em class="bi bi-zoom-in"></em></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<!-- DOWNLOAD style -->
<ng-container *ngIf="displayAsDownloadPage">
    <app-open-all-done-modal [showDownloadButton]="showDownloadButton" [actions]="actions" [documents]="documents" [request]="request"></app-open-all-done-modal>
</ng-container>